import { BettingOptionsFormat } from '@betgames/bg-tools';
import { GameId } from '@bg-shared/enums/GameId';
import { mapToGroupsIds } from '@bg-shared/business/GamesOptions/utils/mapToGroupsIds';
import { mapLotteryOptions } from '../utils/mapLotteryOptions';
import { ILiveLotteryGameState, ILiveLotteryProps } from './interfaces';

export const mapPropsToState = (
    props: ILiveLotteryProps,
    oddsFormat: BettingOptionsFormat,
    gameId: GameId,
): ILiveLotteryGameState => ({
    oddGroups: mapToGroupsIds(props.bettingOptions.groups),
    presetId: props.bettingOptions.preset,
    gameItems: props.bettingOptions.items,
    groups: props.bettingOptions.groups,
    data: {
        gameId,
        roundId: 0,
        runRoundId: 0,
        drawCode: props.draw.drawCode,
        runId: props.draw.runId,
        bettingOptions: mapLotteryOptions({
            gameId,
            options: props.bettingOptions,
            format: oddsFormat,
        }),
    },
});
